var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 373,
    viewBox: "0 0 905 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 220.5,
    y1: 373,
    x2: 220.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 220.5,
    y1: 373,
    x2: 220.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 220.5,
    y1: 373,
    x2: 220.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 283.5,
    y1: 373,
    x2: 283.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 283.5,
    y1: 373,
    x2: 283.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 283.5,
    y1: 373,
    x2: 283.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 344.5,
    y1: 373,
    x2: 344.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 344.5,
    y1: 373,
    x2: 344.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 344.5,
    y1: 373,
    x2: 344.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 408.5,
    y1: 373,
    x2: 408.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 408.5,
    y1: 373,
    x2: 408.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 408.5,
    y1: 373,
    x2: 408.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 468.5,
    y1: 373,
    x2: 468.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 468.5,
    y1: 373,
    x2: 468.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 468.5,
    y1: 373,
    x2: 468.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 532.5,
    y1: 373,
    x2: 532.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 532.5,
    y1: 373,
    x2: 532.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 532.5,
    y1: 373,
    x2: 532.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 593.5,
    y1: 373,
    x2: 593.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 593.5,
    y1: 373,
    x2: 593.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 593.5,
    y1: 373,
    x2: 593.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 657.5,
    y1: 373,
    x2: 657.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 657.5,
    y1: 373,
    x2: 657.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 657.5,
    y1: 373,
    x2: 657.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 733.5,
    y1: 373,
    x2: 733.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 733.5,
    y1: 373,
    x2: 733.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 733.5,
    y1: 373,
    x2: 733.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 797.5,
    y1: 373,
    x2: 797.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 797.5,
    y1: 373,
    x2: 797.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 797.5,
    y1: 373,
    x2: 797.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5,
    y1: 373,
    x2: 91.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5,
    y1: 373,
    x2: 91.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5,
    y1: 373,
    x2: 91.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 373,
    x2: 155.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 373,
    x2: 155.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 373,
    x2: 155.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 314.5,
    x2: 0.0000141859,
    y2: 314.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 314.5,
    x2: 0.0000141859,
    y2: 314.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 314.5,
    x2: 0.0000141859,
    y2: 314.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 250.5,
    x2: 0.0000141859,
    y2: 250.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 250.5,
    x2: 0.0000141859,
    y2: 250.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 250.5,
    x2: 0.0000141859,
    y2: 250.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 189.5,
    x2: 0.0000141859,
    y2: 189.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 189.5,
    x2: 0.0000141859,
    y2: 189.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 189.5,
    x2: 0.0000141859,
    y2: 189.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 125.5,
    x2: 0.0000141859,
    y2: 125.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 125.5,
    x2: 0.0000141859,
    y2: 125.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 125.5,
    x2: 0.0000141859,
    y2: 125.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 49.5,
    x2: 0.0000141859,
    y2: 49.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 49.5,
    x2: 0.0000141859,
    y2: 49.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 905,
    y1: 49.5,
    x2: 0.0000141859,
    y2: 49.5,
    stroke: "#092E43",
    strokeOpacity: 0.29,
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBackground);
export default __webpack_public_path__ + "static/media/grid-background.845e415abee1af27dfcce2a3c65599a3.svg";
export { ForwardRef as ReactComponent };